export const hasPortalAccess = (contact, reviewerOnlyGate)=>{
    if (contact.customerId() == null) return false;
    if (reviewerOnlyGate && contact.isReviewer()) return false;
    if (contact.userId() == null) return false;
    return true;
};
export const portalAccessDisabledTooltip = (param)=>{
    let { contact, clientViewTexts, reviewerOnlyGate } = param;
    if (contact.customerId() == null) return clientViewTexts.menuItemDisabledNoCustomer();
    if (reviewerOnlyGate && contact.isReviewer()) return clientViewTexts.menuItemDisabledReviewerOnly();
    if (contact.userId() == null) return clientViewTexts.menuItemDisabledNoUser();
    return clientViewTexts.menuItemDisabledNoCustomer();
};
